var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-layout-con"},[_c('router-view',{staticClass:"layout_main",class:{
      'lead-theme':
        _vm.currentObj.type != 'index' &&
        (_vm.$route.path.includes('/list/risk') || _vm.$route.name == 'Contact'),
    }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }